(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(6103);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ AuthFormWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87357);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65582);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62623);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28492);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);



var AuthFormWrapper = function(param) {
    var title = param.title, children = param.children;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                children: [
                    title,
                    " | ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                        children: "MUSIC CARE"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                sx: {
                    backgroundColor: "background.login",
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "100vh"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    maxWidth: "sm",
                    sx: {
                        py: 10
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            sx: {
                                display: "flex",
                                justifyContent: "center",
                                pb: 4
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                alt: "FL Logo",
                                src: theme.palette.mode === "light" ? "/logos/music-care-block.png" : "/logos/music-care-block-white.png",
                                width: 185,
                                height: 75
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            sx: {
                                backgroundColor: "background.login",
                                boxShadow: "none"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    p: 3
                                },
                                children: children
                            })
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 33350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ FormikTextField; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22715);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82175);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var FormikTextField = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, {
        name: props.name,
        children: function(param) {
            var field = param.field, meta = param.meta;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                error: Boolean(meta.touched && meta.error),
                helperText: meta.touched && meta.error,
                variant: "outlined"
            }, field, props));
        }
    });
};


/***/ }),

/***/ 46648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ROUTES; }
/* harmony export */ });
/**
 * Global routes table
 */ var ROUTES = {
    // Apply
    APPLY: "/apply",
    CERTIFY: "/certify",
    GROW: "/grow",
    // Auth
    AUTH_LOGIN: "/",
    AUTH_FORGOT_PASSWORD: "/auth/forgot-password",
    AUTH_RESET_PASSWORD: "/auth/forgot-password-reset",
    AUTH_VERIFY_CODE: "/auth/verify-code",
    AUTH_VERIFY_EMAIL: "/auth/verify-email",
    AUTH_CREATE_ACCOUNT: "/register",
    REGISTER_PAYMENT: "/register/payment",
    REGISTER_PLAN_SELECTION: "/register/plan-selection",
    // Music care
    DASHBOARD: "/dashboard",
    CUSTOMERS_ROOT: "/customers",
    CUSTOMERS: "/customers",
    CUSTOMERS_CREATE: "/customers/create",
    CUSTOMERS_VIEW_SINGLE: "/customers/view",
    TRAIN: "/train",
    // Admin
    ADMIN_VIEW_USER: "/admin/view/",
    ADMIN: "/admin/",
    ADMIN_ORGANIZATIONS: "/admin/organizations",
    ADMIN_SCHOOLS: "/admin/schools",
    ADMIN_VIEW_SCHOOL: "/admin/school/",
    ADMIN_VIEW_ORG: "/admin/organization/",
    MEETING: "/meetings",
    MATERIALS: "/materials",
    SESSIONS: "/admin/sessions",
    ASSESSOR_MATERIALS: "/assessor-materials",
    FACILITATOR_MATERIALS: "/facilitator-materials",
    COURSE_CODES: "/course-codes",
    ASSIGN_CERTIFY_FACULTY: "/assign-certify-faculty",
    // Org cert
    ORG_CERT_PLAN: "/organization/plan",
    ORG_CERT_DRIVER: "/organization/driver",
    ORG_CERT_PORTFOLIO: "/organization/portfolio",
    ORG_CERT_ENGAGE: "/organization/engage",
    ORG_CERT_ENGAGE_LTD: "/organization/engageLimited",
    ORG_CERT_REGISTRY: "/organization/orgRegistry",
    ORG_CERT_GROW: "/organization/grow",
    ORG_CERT_RECERTIFY: "/organization/recertify",
    // School cert
    SCHOOL_CERT_PLAN: "/school/plan",
    SCHOOL_CERT_DRIVER: "/school/driver",
    SCHOOL_CERT_PORTFOLIO: "/school/portfolio",
    SCHOOL_CERT_ENGAGE: "/school/engage",
    SCHOOL_CERT_REGISTRY: "/school/registry",
    SCHOOL_CERT_GROW: "/school/grow",
    // Misc
    UNAUTHORIZED: "/unauthorized",
    PROFILE: "/profile",
    TEST_EDITOR: "/test-editor"
};


/***/ }),

/***/ 78470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var contexts_AuthContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46978);


var useAuth = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(contexts_AuthContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
};
/* harmony default export */ __webpack_exports__["Z"] = (useAuth);


/***/ }),

/***/ 60128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useIsMountedRef = function() {
    var isMounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        return function() {
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsMountedRef);


/***/ }),

/***/ 8959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var contexts_MFAContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71296);

/* harmony default export */ __webpack_exports__["Z"] = (contexts_MFAContext__WEBPACK_IMPORTED_MODULE_0__/* .useMFA */ .H);


/***/ }),

/***/ 6103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(23972);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(37786);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/queries/useProfileByProfileIdQuery.ts
var useProfileByProfileIdQuery = __webpack_require__(75826);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(77058);
// EXTERNAL MODULE: ./src/components/authentication/AuthFormWrapper.tsx
var AuthFormWrapper = __webpack_require__(6195);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormHelperText/FormHelperText.js
var FormHelperText = __webpack_require__(74509);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(69397);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/notistack/dist/notistack.esm.js + 1 modules
var notistack_esm = __webpack_require__(50841);
// EXTERNAL MODULE: ./src/queries/useResendConfirmationEmail.ts
var useResendConfirmationEmail = __webpack_require__(46649);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 26 modules
var es = __webpack_require__(7258);
// EXTERNAL MODULE: ./src/components/formik/FormikTextField.tsx
var FormikTextField = __webpack_require__(33350);
// EXTERNAL MODULE: ./src/constants/routes.ts
var routes = __webpack_require__(46648);
// EXTERNAL MODULE: ./src/hooks/useAuth.ts
var useAuth = __webpack_require__(78470);
// EXTERNAL MODULE: ./src/hooks/useIsMountedRef.ts
var useIsMountedRef = __webpack_require__(60128);
// EXTERNAL MODULE: ./src/hooks/useMFA.ts
var useMFA = __webpack_require__(8959);
;// CONCATENATED MODULE: ./src/components/authentication/login/index.tsx
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */ 



















// Lazy load MFA modals for better performance
var MFASetupModal = /*#__PURE__*/ (0,react.lazy)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
    var mfaSetupModule;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    Promise.all(/* import() */[__webpack_require__.e(6032), __webpack_require__.e(4888), __webpack_require__.e(4602)]).then(__webpack_require__.bind(__webpack_require__, 34602))
                ];
            case 1:
                mfaSetupModule = _state.sent();
                return [
                    2,
                    {
                        default: mfaSetupModule.MFASetupModal
                    }
                ];
        }
    });
}));
var MFAVerificationModal = /*#__PURE__*/ (0,react.lazy)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
    var mfaVerificationModule;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    Promise.all(/* import() */[__webpack_require__.e(6032), __webpack_require__.e(2212)]).then(__webpack_require__.bind(__webpack_require__, 82212))
                ];
            case 1:
                mfaVerificationModule = _state.sent();
                return [
                    2,
                    {
                        default: mfaVerificationModule.MFAVerificationModal
                    }
                ];
        }
    });
}));
var initialValues = {
    email: "",
    password: ""
};
var LoginForm = function(props) {
    var isMountedRef = (0,useIsMountedRef/* default */.Z)();
    var i18n = (0,useTranslation/* useTranslation */.$)().i18n;
    var ref = (0,useAuth/* default */.Z)(), login = ref.login, completeMFALogin = ref.completeMFALogin, mfaState = ref.mfaState;
    var verifyCode = (0,useMFA/* default */.Z)().verifyCode;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), resendEmail = ref1[0], setResendEmail = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), showResendEmail = ref2[0], setShowResendEmail = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useResendConfirmationEmail/* useResendConfirmationEmailMutation */.N)(), 1), resendEmailConfirmation = ref3[0];
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    // MFA modal state
    var ref4 = (0,react.useState)(false), showMFASetup = ref4[0], setShowMFASetup = ref4[1];
    var ref5 = (0,react.useState)(false), showMFAVerification = ref5[0], setShowMFAVerification = ref5[1];
    var ref6 = (0,react.useState)(false), isCompletingLogin = ref6[0], setIsCompletingLogin = ref6[1];
    var loginFormSchema = es/* object */.Ry({
        email: es/* string */.Z_().required(i18n.t("login.email.error")),
        password: es/* string */.Z_().required(i18n.t("login.password.error")),
        submit: es/* string */.Z_()
    });
    var handleSubmitLogin = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values, param) {
            var setErrors, setSubmitting, mfaResult, err, errorMessage;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setErrors = param.setErrors, setSubmitting = param.setSubmitting;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            login({
                                email: values.email,
                                password: values.password
                            })
                        ];
                    case 2:
                        mfaResult = _state.sent();
                        if (isMountedRef.current) {
                            // Check if MFA is required
                            if (mfaResult.requiresSetup) {
                                // Show MFA setup modal
                                setShowMFASetup(true);
                                setSubmitting(false);
                            } else if (mfaResult.requiresMFA) {
                                // Show MFA verification modal
                                setShowMFAVerification(true);
                                setSubmitting(false);
                            } else {
                                // No MFA required, proceed to dashboard
                                router.push(routes/* ROUTES.DASHBOARD */.Z.DASHBOARD);
                                setSubmitting(false);
                            }
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        if (isMountedRef.current) {
                            errorMessage = err.message;
                            setErrors({
                                submit: errorMessage
                            });
                            setResendEmail(values.email);
                            // Check if user needs to verify their email
                            if (errorMessage === "You must confirm your email before logging in") {
                                setShowResendEmail(true);
                                // Redirect to verify email page after a short delay
                                setTimeout(function() {
                                    router.push(routes/* ROUTES.AUTH_VERIFY_EMAIL */.Z.AUTH_VERIFY_EMAIL);
                                }, 2000);
                            }
                            setSubmitting(false);
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmitLogin(values, _) {
            return _ref.apply(this, arguments);
        };
    }();
    var tryResendConfirmationEmail = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!resendEmail) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            resendEmailConfirmation({
                                variables: {
                                    email: resendEmail
                                }
                            })
                        ];
                    case 2:
                        _state.sent();
                        enqueueSnackbar("Resent!", {
                            variant: "success"
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        enqueueSnackbar("An Error Occurred", {
                            variant: "error"
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function tryResendConfirmationEmail() {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * Handle MFA setup completion
   * Called when user successfully verifies their TOTP code during setup
   */ var handleMFASetupComplete = (0,react.useCallback)(function() {
        // Close setup modal
        setShowMFASetup(false);
        // User needs to log in again with their new MFA code
        enqueueSnackbar("MFA setup complete! Please log in with your password and authenticator code.", {
            variant: "info"
        });
    }, [
        enqueueSnackbar
    ]);
    /**
   * Handle MFA verification completion
   * Called when user successfully verifies their TOTP code during login
   */ var handleMFAVerificationComplete = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(code) {
            var username, session, result;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        username = mfaState.username;
                        session = mfaState.mfaSession;
                        if (!username || !session) {
                            throw new Error("Missing username or session for MFA verification");
                        }
                        return [
                            4,
                            verifyCode({
                                username: username,
                                code: code,
                                session: session
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        if (!result.success) {
                            throw new Error("MFA verification failed");
                        }
                        /*
       * Store session tokens after successful MFA verification
       */ if (result.sessionTokens) {
                            localStorage.setItem("access-token", result.sessionTokens.access);
                            localStorage.setItem("refresh-token", result.sessionTokens.refresh);
                            localStorage.setItem("id-token", result.sessionTokens.id);
                        }
                        /*
       * Show completing login state in modal
       */ setIsCompletingLogin(true);
                        /*
       * Complete login flow - update auth context and redirect to dashboard
       */ return [
                            4,
                            completeMFALogin()
                        ];
                    case 2:
                        _state.sent();
                        // Close verification modal
                        setShowMFAVerification(false);
                        setIsCompletingLogin(false);
                        enqueueSnackbar("Login successful", {
                            variant: "success"
                        });
                        // Small delay to ensure auth context propagates before navigation
                        return [
                            4,
                            new Promise(function(resolve) {
                                setTimeout(resolve, 100);
                            })
                        ];
                    case 3:
                        _state.sent();
                        void router.push(routes/* ROUTES.DASHBOARD */.Z.DASHBOARD);
                        return [
                            2
                        ];
                }
            });
        });
        return function(code) {
            return _ref.apply(this, arguments);
        };
    }(), [
        verifyCode,
        completeMFALogin,
        router,
        enqueueSnackbar,
        mfaState
    ]);
    /**
   * Handle MFA modal cancellation
   */ var handleMFACancel = (0,react.useCallback)(function() {
        setShowMFASetup(false);
        setShowMFAVerification(false);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                initialValues: initialValues,
                validationSchema: loginFormSchema,
                onSubmit: handleSubmitLogin,
                children: function(param) {
                    var errors = param.errors, isSubmitting = param.isSubmitting;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikTextField/* FormikTextField */.f, {
                                name: "email",
                                autoFocus: true,
                                autoComplete: "username",
                                fullWidth: true,
                                label: i18n.t("login.email.useremail"),
                                margin: "normal",
                                type: "username"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikTextField/* FormikTextField */.f, {
                                name: "password",
                                autoComplete: "password",
                                fullWidth: true,
                                label: i18n.t("login.password.label"),
                                margin: "normal",
                                type: "password"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: routes/* ROUTES.AUTH_FORGOT_PASSWORD */.Z.AUTH_FORGOT_PASSWORD,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        sx: {
                                            pt: 1
                                        },
                                        children: i18n.t("login.forgot_password")
                                    })
                                })
                            }),
                            errors.submit && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    mt: 3
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                                    error: true,
                                    children: errors.submit
                                })
                            }),
                            showResendEmail ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    mt: 2
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    color: "secondary",
                                    fullWidth: true,
                                    size: "large",
                                    variant: "contained",
                                    onClick: function() {
                                        tryResendConfirmationEmail();
                                    },
                                    children: "Resend my verification email"
                                })
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    mt: 2
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    disabled: isSubmitting,
                                    fullWidth: true,
                                    size: "large",
                                    type: "submit",
                                    variant: "contained",
                                    color: "secondary",
                                    children: i18n.t("login.loginbutton")
                                })
                            })
                        ]
                    }));
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                fallback: null,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MFASetupModal, {
                    open: showMFASetup,
                    onClose: handleMFACancel,
                    onComplete: handleMFASetupComplete,
                    mfaSession: mfaState.mfaSession
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                fallback: null,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MFAVerificationModal, {
                    open: showMFAVerification,
                    onVerify: handleMFAVerificationComplete,
                    onCancel: handleMFACancel,
                    isCompletingLogin: isCompletingLogin
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/index.tsx
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */ 










var Login = function() {
    var i18n = (0,useTranslation/* useTranslation */.$)().i18n;
    var user = (0,useAuth/* default */.Z)().user;
    var router = (0,next_router.useRouter)();
    var hasProfileId = Boolean(user === null || user === void 0 ? void 0 : user.profile_id);
    var ref;
    var ref1 = (0,useProfileByProfileIdQuery/* useProfileByProfileIdQuery */.Y)({
        variables: {
            profileId: (ref = user === null || user === void 0 ? void 0 : user.profile_id) !== null && ref !== void 0 ? ref : ""
        },
        skip: !hasProfileId
    }), profile = ref1.data, profileLoading = ref1.loading;
    react.useEffect(function() {
        /*
     * Wait for a definitive answer on the plan before deciding: on first
     * render `profile` is still undefined (the query hasn't resolved, or
     * hasn't even started yet without a profile_id), which looked
     * indistinguishable from "no plan" and sent every first_login account
     * straight to plan-selection — even ones with a real subscription.
     */ if (!hasProfileId || profileLoading) return;
        if ((user === null || user === void 0 ? void 0 : user.first_login) && !(profile === null || profile === void 0 ? void 0 : profile.profileByProfileId.plan)) {
            router.push(routes/* ROUTES.REGISTER_PLAN_SELECTION */.Z.REGISTER_PLAN_SELECTION);
        } else if ((user === null || user === void 0 ? void 0 : user.first_login) === false) {
            router.push(routes/* ROUTES.DASHBOARD */.Z.DASHBOARD);
        }
    }, [
        user,
        router,
        profile,
        profileLoading,
        hasProfileId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthFormWrapper/* AuthFormWrapper */.f, {
        title: "Login",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    flexGrow: 1
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginForm, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    justifyContent: "center",
                    columnGap: 0.5,
                    mt: 3
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        color: "textSecondary",
                        variant: "body1",
                        style: {
                            fontSize: "1rem"
                        },
                        children: i18n.t("login.no_account")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: routes/* ROUTES.AUTH_CREATE_ACCOUNT */.Z.AUTH_CREATE_ACCOUNT,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            sx: {
                                p: 0
                            },
                            style: {
                                fontSize: "1rem"
                            },
                            children: i18n.t("login.sign_up")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pages = (Login);


/***/ }),

/***/ 75826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ PROFILE_BY_PROFILE_ID_QUERY; },
/* harmony export */   "Y": function() { return /* binding */ useProfileByProfileIdQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75063);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6812);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetProfileByProfileId($profileId: String!) {\n    profileByProfileId(profileId: $profileId) {\n      profile_id\n      firstName\n      lastName\n      organization\n      email\n      subscribed\n      registration_date\n      certified\n      recertify\n      email_verified\n      cognito_status\n      plan {\n        plan_id\n        name\n        description\n        max_licenses\n        is_archived\n        created_at\n        type\n        updated_at\n        stripe_product_id\n        billing_cycle\n        trial_period_days\n        prices {\n          id\n          currency\n          unit_amount\n        }\n      }\n      roles {\n        role_id\n        name\n        description\n        created_at\n        updated_at\n      }\n      sessions {\n        learn_session_instance_id\n        learn_session_id\n        notes\n        grade\n        created_at\n        updated_at\n        reviewed_by\n        completed_at\n        reviewed_at\n        description\n        start_at\n        end_at\n        level\n        code\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var PROFILE_BY_PROFILE_ID_QUERY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var useProfileByProfileIdQuery = function(options) {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .aM)(PROFILE_BY_PROFILE_ID_QUERY, options);
};


/***/ }),

/***/ 46649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useResendConfirmationEmailMutation; }
/* harmony export */ });
/* unused harmony export RESEND_CONFIMATION_EMAIL_MUTATION */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75063);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50319);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation ResendConfirmationEmail($email: String!) {\n    resendConfirmationEmail(email: $email) {\n      message\n      success\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var RESEND_CONFIMATION_EMAIL_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var useResendConfirmationEmailMutation = function(options) {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)(RESEND_CONFIMATION_EMAIL_MUTATION, options);
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8598,7711,5675,4097,4914,7691,5324,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);